import { render } from "./Token.vue?vue&type=template&id=5be72b9f"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"
script.render = render

export default script